import firebase from "../../firebase";

export default function (data) {
  return firebase.functions().httpsCallable("allFunctions")({
    funcRole: "superAdmin",
    funcName: "createCoupon",
    data
  });
}